//import { MobileAlertModalComponent } from './../mobile-alert-modal/mobile-alert-modal.component';
import { GlobalGridModeService } from './../../../services/globalGridMode/globalGridMode.service';
import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TradeClosedRs } from '../../../interfaces/service.response';
import { MainUIServiceService } from "../../../services/main-uiservice.service";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import *  as html2canvas from 'html2canvas';  
import * as $ from "jquery";
import { Utils } from '../../../utils';
import { ShareProvider, ShareService } from '../../../services/share.service';
import { Alert } from '../../../model/alert';
import { OrderOperationType } from '../orderentry/orderentry.component';
import { WorkspaceServiceService } from '../../../services/workspace-service.service';
import { AlertState } from '../../../enums/alert-state';
import { ShowModalOrderEntry } from '../orderentry/show-order-entry-modal';


@Component({
    selector: 'alert-modal',
    template: require('./alert-modal.component.html'),
    styles: [require('./alert-modal.component.css')]
})
export class  AlertModalComponent {
    public alert!: Alert;
    constructor(
        public workspaceService: WorkspaceServiceService,
        public modalService: NgbModal,
        public dataService: DataService,
        public globalGridMode: GlobalGridModeService,
        public activeModal: NgbActiveModal
    ) {
    }

    public isAlertTraded(alert: Alert)
    {
        return this.workspaceService.data.getAlertState(alert) == AlertState.Traded;
    }
    

    public setAlertTraded(alert: Alert)
    {
        if(!this.isAlertTraded(alert))
        this.workspaceService.data.setAlertState(alert, AlertState.Traded)
    }

    public newSymbol(event: MouseEvent, alert: Alert) {
        event.stopPropagation();
        this.workspaceService.data.activeAlertId = this.workspaceService.data.openedAlertId = alert.Id;
        this.activeModal.dismiss();
        this.workspaceService.data.activeAlertId = this.workspaceService.data.openedAlertId = alert.Id;
        this.globalGridMode.emitSymbolChanged({ symbol: alert.CurrencyPair, overrideLockAllCharts: false });
    }

    public tButtonClick(event: MouseEvent, alert: Alert)
    {
        event.stopPropagation();
        this.activeModal.dismiss();
        this.workspaceService.data.activeAlertId = this.workspaceService.data.openedAlertId = alert.Id;
        this.openOrderModal(alert);
    }

    openOrderModal(alert: Alert) {
        this.setAlertTraded(alert);
        const item = this.workspaceService.data.boxes.find(b => b.Symbol == alert.CurrencyPair)
        if(item == null)
            return;

        ShowModalOrderEntry(
            item.Symbol,
            item.Ask,
            this.modalService,
            alert.TradeDirection != null && alert.TradeDirection.toLowerCase().includes("short")? OrderOperationType.Sell: OrderOperationType.Buy,
            item.Type,
            this.workspaceService.data.mobileMode,
            undefined,
            this.workspaceService.data.newOrderLayout
        );
    }
}